import Reflux from "reflux";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import UserNotification from "util/UserNotification";
export const ForwarderInputTypesActions = Reflux.createActions({
  list: { asyncResult: true },
  get: { asyncResult: true }
});
const ForwarderInputTypesStore = Reflux.createStore({
  listenables: [ForwarderInputTypesActions],
  sourceUrl: "/plugins/org.graylog.plugins.forwarder/forwarder/inputs/types",
  forwarderInputTypes: void 0,
  forwarderInputDescriptions: void 0,
  init() {
    this.list();
  },
  getInitialState() {
    return {
      forwarderInputTypes: this.forwarderInputTypes,
      forwarderInputDescriptions: this.forwarderInputDescriptions
    };
  },
  list() {
    const promiseTypes = fetch("GET", qualifyUrl(this.sourceUrl));
    const promiseDescriptions = fetch("GET", qualifyUrl(`${this.sourceUrl}/all`));
    const promise = Promise.all([promiseTypes, promiseDescriptions]);
    promise.then(
      ([typesResponse, descriptionsResponse]) => {
        this.forwarderInputTypes = typesResponse.types;
        this.forwarderInputDescriptions = descriptionsResponse;
        this.trigger(this.getInitialState());
      },
      (error) => {
        UserNotification.error(`Fetching Input Types failed with status: ${error}`, "Could not retrieve Inputs");
      }
    );
    ForwarderInputTypesActions.list.promise(promise);
  },
  get(inputTypeId) {
    const promise = fetch("GET", qualifyUrl(`${this.sourceUrl}/${inputTypeId}`));
    promise.catch((error) => {
      UserNotification.error(`Fetching input ${inputTypeId} failed with status: ${error}`, "Could not retrieve input");
    });
    ForwarderInputTypesActions.get.promise(promise);
  }
});
export default ForwarderInputTypesStore;
